import { useCallback, useRef } from 'react'

export function useDebouncedCallback<A,>(func: (...args: A[]) => void, wait: number) {
  const timeout = useRef<NodeJS.Timeout | undefined>(undefined)

  return useCallback(
    (...args: A[]) => {
      const later = () => {
        clearTimeout(timeout.current)
        func(...args)
      }

      clearTimeout(timeout.current)
      timeout.current = setTimeout(later, wait)
    },
    [func, wait],
  )
}
